const useSkeletons = () => {
  return {};
};

export default useSkeletons;
